var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-container scroll"},[_c('NavCom'),_c('StoreCom',{attrs:{"nav":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }